module.exports = __webpack_public_path__ + "static/img/science_technology_intensity_3.016cfca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/science_technology_intensity_3.png
// module id = J+Ed
// module chunks = 6